export function draftFromRows(rows) {
    return rows.reduce((draft, row) => {
        draft[row.type] = row.enabled;
        return draft;
    }, {});
}
export function desiredFor(row, draft) {
    var _a;
    return (_a = draft[row.type]) !== null && _a !== void 0 ? _a : row.enabled;
}
export function hasChanges(rows, draft) {
    return rows.some((row) => desiredFor(row, draft) !== row.enabled);
}
export function deviatesFromDefault(row, draft) {
    return desiredFor(row, draft) !== row.defaultEnabled;
}
/**
 * The FULL desired state, as an array rather than a type-keyed object so the
 * API client's snake/camel case conversion never rewrites a type name. Rails
 * keeps only the entries that differ from the catalog default.
 */
export function toPayload(rows, draft, masterEnabled) {
    return { types: rows.map((row) => ({ type: row.type, enabled: desiredFor(row, draft) })), masterEnabled };
}
